import { Component, NgModule, OnInit } from '@angular/core';
// import { Routes, RouterModule } from '@angular/router';
import { Routes, RouterModule, ActivatedRoute } from '@angular/router';
import { AccountsComponent } from '../app/accounts/accounts.component';
import { VoucherEntryComponent } from '../app/voucher-entry/voucher-entry.component';
import { LedgerRecordComponent } from '../app/ledger-record/ledger-record.component';
import { HeadsComponent } from '../app/heads/heads.component';
import { BalanceSheetComponent } from '../app/balance-sheet/balance-sheet.component';
import { DailyStockComponent } from '../app/daily-stock/daily-stock.component';
import { ProfitandLossComponent } from '../app/profitand-loss/profitand-loss.component';
import { RprtCreateComponent } from '../app/rprt-create/rprt-create.component';
import { TrialBalanceComponent } from './trial-balance/trial-balance.component';
import { GSTR3BComponent } from './gstr3-b/gstr3-b.component'
import { ReconciliationComponent } from './reconciliation/reconciliation.component'
import { AccountReportsComponent } from './account-reports/account-reports.component'

// import { PayrollComponent } from './payroll/payroll.component';
// import { AttendanceComponent } from './attendance/attendance.component';
import { LedgersComponent } from './ledgers/ledgers.component';
import { FinancialYearcountComponent } from './financial-yearcount/financial-yearcount.component';
import { VoucherPrintComponent } from './Printables/Voucher/voucher-print/voucher-print.component';
import { LedgerRecordPrintComponent } from './Printables/ledger-record-print/ledger-record-print.component';
import { RecentVouchersComponent } from './recent-vouchers/recent-vouchers.component';
import { TranjectionsPrintComponent } from './Printables/Tranjections/tranjections-print/tranjections-print.component';
import { VoucherSearchComponent } from './voucher-search/voucher-search.component'
// import { EmployeeSettingComponent } from './employee-setting/employee-setting.component';
// import { EmployeeComponent } from './employee/employee.component';
import { PrintComponent } from './Printables/BalanceSheet/print/print.component';
import { PrintProfitLossComponent } from './Printables/ProfitLoss/print-profit-loss/print-profit-loss.component';
import { BankReconciliationPrintComponent } from './Printables/bank-reconciliation-print/bank-reconciliation-print.component';
import { HeadRecordComponent } from './head-record/head-record.component'
import { SalesSummaryComponent } from './sales-summary/sales-summary.component';
import { AuthGuardService } from './services/auth-guard.service';
import { JobcardPrintComponent } from './Printables/jobcard-print/jobcard-print.component';
import { LedgerEntryComponent } from './ledger-entry/ledger-entry.component';
import { PaymentReceiptComponent } from './Printables/payment-receipt/payment-receipt.component';
import { BomPrintComponent } from './Printables/bom-print/bom-print.component';
import { BasicPrdPrintComponent } from './Printables/basic-prd-print/basic-prd-print.component';
import { FindCompComponent } from './find-comp/find-comp.component';
import { CreateProductionJobComponent } from './production/create-production-job/create-production-job.component';
import { ProductionJobCreationComponent } from './production/production-job-creation/production-job-creation.component';
import { ValidateImportItemsComponent } from './inventory/validate-import-items/validate-import-items.component';
import { DayBookComponent } from './day-book/day-book.component';
import { AccountsSettingsComponent } from './accounts-settings/accounts-settings.component';
import { AccountsGroupPrefComponent } from './accounts-group-pref/accounts-group-pref.component';

const routes: Routes = [
  { path: 'accounts', component: AccountsComponent, canActivate:[AuthGuardService]},
  { path: 'voucher', component: VoucherEntryComponent, canActivate:[AuthGuardService]},
  { path: 'ledger', component: LedgerRecordComponent, canActivate:[AuthGuardService]},
  { path: 'head', component: HeadsComponent, canActivate:[AuthGuardService]  },
  { path: 'balanceSheet', component: BalanceSheetComponent, canActivate:[AuthGuardService]},
  { path: 'dailyStock', component: DailyStockComponent, canActivate:[AuthGuardService]},
  { path: 'profitandLoss', component: ProfitandLossComponent, canActivate:[AuthGuardService]},
  { path: 'rprtCreate', component: RprtCreateComponent, canActivate:[AuthGuardService] },
  { path: 'trialBalance', component: TrialBalanceComponent },
  { path: 'GSTR3B', component: GSTR3BComponent, canActivate:[AuthGuardService] },
  { path: 'Reconciliation', component: ReconciliationComponent, canActivate:[AuthGuardService] },
  { path: 'AcctReport', component: AccountReportsComponent, canActivate:[AuthGuardService] },
  // { path: 'payroll', component: PayrollComponent, canActivate:[AuthGuardService] },
  // { path: 'attendance', component: AttendanceComponent, canActivate:[AuthGuardService] },
  { path: 'LedgerRecord', component: LedgersComponent, canActivate:[AuthGuardService] },
  { path: 'voucherPrint', component: VoucherPrintComponent, canActivate:[AuthGuardService] },
  // { path: 'attendance', component: AttendanceComponent, canActivate:[AuthGuardService] },
  { path: 'financialyearcount', component: FinancialYearcountComponent, canActivate:[AuthGuardService] },
  { path: 'LedgerRecordPrint', component: LedgerRecordPrintComponent, canActivate:[AuthGuardService]},
  { path: 'recentvoucher', component: RecentVouchersComponent, canActivate:[AuthGuardService] },
  { path: 'transactionHistory', component : TranjectionsPrintComponent, canActivate:[AuthGuardService]},
  { path: 'VoucherSearch', component: VoucherSearchComponent, canActivate:[AuthGuardService]},
  // { path: 'employeesetting', component: EmployeeSettingComponent },
  // { path: 'employee', component: EmployeeComponent }
  { path: 'BalanceSheetPrint', component: PrintComponent, canActivate:[AuthGuardService] },
  { path: 'PrintProfitLoss', component: PrintProfitLossComponent, canActivate:[AuthGuardService] },
  { path: 'reconciliationprint', component: BankReconciliationPrintComponent, canActivate:[AuthGuardService] },
  { path: 'HeadRecord', component: HeadRecordComponent, canActivate:[AuthGuardService]},
  { path: 'SalesSummary', component: SalesSummaryComponent, canActivate:[AuthGuardService]},

  // { path: 'jobcardPrint', component: JobcardPrintComponent, canActivate:[AuthGuardService]},
  { path: 'jobcardPrint', component: JobcardPrintComponent, canActivate:[AuthGuardService], data: { viewOption: 'jobcardPrint' } },
  { path: 'ProjectTracker', component: JobcardPrintComponent, canActivate:[AuthGuardService], data: { viewOption: 'ProjectTracker' } },
  { path: 'LedgerEntry', component: LedgerEntryComponent},
  { path: 'paymentReceipt', component: PaymentReceiptComponent},
  { path: 'prodBOMPrint', component: BomPrintComponent},
  { path: 'BasicPrdPrint', component: BasicPrdPrintComponent},
  { path: 'FindComp', component: FindCompComponent },
  { path: 'CreateJob', component: ProductionJobCreationComponent },
  { path: 'ImportItems', component: ValidateImportItemsComponent },
  { path: 'DayBook', component: DayBookComponent},
  { path: 'AccountsSettings', component: AccountsSettingsComponent },
  { path: 'GroupPrefModal', component: AccountsGroupPrefComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
// export class AppRoutingModule { }
export class AppRoutingModule implements OnInit{ 
  constructor( private route: ActivatedRoute ) {}

  viewOption : any;
  ngOnInit() {
    debugger
    this.viewOption = this.route.snapshot.data.viewOption;
  }
}
